import styled from 'styled-components'

export const Container = styled.div`
    min-height: calc(
            100vh - ${(props) => {return props.theme.headerHeight}}px
                - ${(props) => {return props.theme.footerHeight}}px
        );
    color: ${(props) => {return props.theme.colorPrimary}};
    display: flex;
    flex-direction: column;

    > div {
        display: flex;
        flex-direction: column;
        padding: 30px 10px 20px;
        height: 1fr;
        width: 1100px;
        max-width: 100%;
        margin: 0 auto;
    }

    .hidden {
        display: none !important;
    }

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .content {
        box-shadow: ${(props) => {return props.theme.shadow}};
        border: 1px solid #eee;
        border-radius: 10px;
        padding: 30px 20px;
        box-sizing: content-box;
        flex-direction: column;

        .hidden {
            display: none;
        }

        .spinner-box {
            display: flex;
            justify-content: end;
            align-items: center;
            flex-direction: column;
            height: 150px;

            .sk-spinner {
                transform: scale(2);
            }

            span {
                margin-top: 40px;
                font-size: 1.3rem;
            }
        }

        @media screen and (max-width: 900px) {
            padding: 20px 10px;
        }
    }

    .mais {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0 20px;

        div {
            width: max-content;
            background-color: rgba(228,228,228,.22);
            padding: 3px 25px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #1A354940;
            font-size: .8rem;

            &:hover {
                border: 1px solid;
            }
        }
    }
`
